<template>
	<!-- Place Order page -->
	<Layout>
		<!-- <div class="row">
			<div class="col-12">
				<div class="page-title-box">
					<h4 class="page-title">{{ $t('PORTAL.Place Order.heading') }}</h4>
				</div>
			</div>
		</div> -->
		<div class="row">
			<div class="col">
				<br />
				<FileUpload />
			</div>
		</div>
		<div class="row">
			<div class="col">
				<br />
				<SpreadsheetSubmissions />
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/views/layouts/Main.vue'
import FileUpload from '@/components/FileUpload.vue'
import SpreadsheetSubmissions from '@/components/SpreadsheetSubmissions.vue'
import { placeOrderComputed } from '@/store/helpers'

const { VUE_APP_ENV } = process.env

export default {
	name: 'PlaceOrder',
	page: {
		title: `${
			VUE_APP_ENV !== 'prd' ? VUE_APP_ENV.toUpperCase() : ''
		} Place Order`,
		meta: [{ name: 'description', content: 'Place Order' }]
	},
	components: {
		Layout,
		FileUpload,
		SpreadsheetSubmissions
	},
	computed: {
		...placeOrderComputed
	},
	created() {
		window.onbeforeunload = () => {
			if (this.uiState === 'VALIDATE_SUCCESS') {
				return this.$t(
					'PORTAL.Place Order.unsaved_changes_prompt_message'
				)
			}
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.uiState === 'VALIDATE_SUCCESS') {
			const answer = window.confirm(
				this.$t('PORTAL.Place Order.unsaved_changes_prompt_message')
			)
			if (answer) {
				next()
			} else {
				next(false)
			}
		} else {
			next()
		}
	}
}
</script>
